import React from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import PropTypes from "prop-types";
import ReactCountryFlag from "react-country-flag";
import CustomCheckBox from "../../../../components/CheckBox/index";
import trashIcon from "../../../../assets/images/trash.svg";

const UserAccesTable = ({
  accesslists,
  paginationOnchange,
  paginationFisrt,
  paginationRows,
  hanleChangeUpdateAccess,
  updatEntity,
  openDeleteModal,
  tenantId,
  tenantName,
  role,
}) => {
  const isGxmAdmin = role === "GXM_ADMIN" || role === "SUPER_ADMIN";
  const isCustomer = role === "CUSTOMER" || role === "CUSTOMER_MANAGER";

  const buildEntityNode = (entity) => ({
    key: `entity-${entity.id}`,
    data: {
      name: (
        <span>
          <ReactCountryFlag countryCode={entity.country} svg className="mr-2" />
          {`${entity.name} (${entity.country})`}
        </span>
      ),
      status: null,
      action: (
        <img
          src={trashIcon}
          alt="Delete"
          className="delete-access"
          onClick={() => openDeleteModal(entity)}
        />
      ),
    },
    children: entity.services?.map((service) => {
      return {
        key: `service-${service.id}`,
        data: {
          name: service.name,
          status: null,
          action: null,
        },
        children: service.process_templates?.map((process) => {
          const isAvailable = updatEntity?.find(
            (x) =>
              x.entityId == entity.id &&
              x.serviceId == service.id &&
              x.processId == process.id,
          );
          const isChecked = isAvailable ? isAvailable.checked : true;
          return {
            key: `process-${process.id}`,
            data: {
              name: process.name,
              status: (
                <div className="flex  text-center checkbox-margin">
                  <CustomCheckBox
                    inputId={`checkbox-${process.id}`}
                    checked={isChecked}
                    onChange={(e) =>
                      hanleChangeUpdateAccess(
                        e.target.checked,
                        entity.id,
                        service.id,
                        process.id,
                      )
                    }
                  />
                </div>
              ),
              action: null,
            },
          };
        }),
      };
    }),
  });

  const convertToTreeNodes = (data) => {
    // Customer User/Manager: flat entity list (no tenant grouping)
    // Entity → Service → Process Templates
    if (isCustomer) {
      return data.map((entity) => buildEntityNode(entity));
    }

    // GXM Admin / Super Admin: show only tenant (no entities/services)
    if (isGxmAdmin) {
      return [
        {
          key: `tenant-${tenantId}`,
          data: {
            name: <span>{tenantName || "Tenant"}</span>,
            status: null,
            action: null,
          },
        },
      ];
    }

    // LSP User/Manager & GXM User/Manager: full tree Tenant → Entity → Service → Process Templates
    const tenantNode = {
      key: `tenant-${tenantId}`,
      data: {
        name: <span>{tenantName || "Tenant"}</span>,
        status: null,
        action: null,
      },
      children: data.map((entity) => buildEntityNode(entity)),
    };
    return [tenantNode];
  };

  const treeNodes = convertToTreeNodes(accesslists || []);

  return (
    <div
      className={`user-access-table${isGxmAdmin ? " user-access-table--gxm-admin" : ""}`}
    >
      <TreeTable
        value={treeNodes}
        emptyMessage="No results were found"
        responsiveLayout="scroll"
        paginator={accesslists?.length > 10}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        rowsPerPageOptions={[10, 20, 30]}
        first={paginationFisrt}
        rows={paginationRows}
        onPage={paginationOnchange}
      >
        <Column
          field="name"
          header={
            isGxmAdmin ? (
              <span>
                Account Name{" "}
                <i
                  className="pi pi-info-circle info-icon"
                  id="gxm-admin-access-info"
                />
                <Tooltip
                  target="#gxm-admin-access-info"
                  content="GXM Admin users inherit full visibility across all entities, processes, and services within the tenant."
                  position="right"
                  className="gxm-admin-tooltip"
                />
              </span>
            ) : (
              "Account Name"
            )
          }
          expander={!isGxmAdmin}
          className="table-entity-column"
        />

        {!isGxmAdmin && <Column field="action" />}
      </TreeTable>
    </div>
  );
};

UserAccesTable.propTypes = {
  accesslists: PropTypes.array,
  paginationOnchange: PropTypes.func,
  paginationFisrt: PropTypes.number,
  paginationRows: PropTypes.number,
  hanleChangeUpdateAccess: PropTypes.func,
  updatEntity: PropTypes.array,
  openDeleteModal: PropTypes.func,
  tenantId: PropTypes.string,
  tenantName: PropTypes.string,
  role: PropTypes.string,
};

export default UserAccesTable;
